import { OrgSubscriptions } from './../../../modules/organizations/OrganizationPage/Components/Billing/OrgSubscriptions';
import { CompactUserResponse, UserId, VeryCompactUserResponse } from '@business/entities/account';
import { BrandId, BrandResponse } from '@business/entities/brand';
import { PageQuery } from '@business/entities/common';
import { ContactId, ContactOrgRequest } from '@business/entities/contact';
import { OrgId } from '@business/entities/organization';
import { SupportCategoryId, SupportCategoryResponse } from '@business/entities/SupportCategories';
import { ChannelEmailSender, ChannelId, CompactChannelResponse } from '@business/entities/SupportChannel';
import { TenantId } from '@business/entities/tenant';
import { CompactOrgResponse } from '../organization';
import { TicketEmailsResponse } from './TicketEmailsResponse';
import { TicketFileResponse } from './TicketFileResponse';
import { TicketReplyResponse, TicketReplyResponseType } from './TicketReplyResponse';
import { LineItem } from '../project/SubscriptionResponse';

export type TicketId = string;

export enum SupportTicketStatus {
  replied = '0',
  open = '1',
  closed = '2',
  markNotification = '3',
  markSpam = '4',
}

export enum SupportTicketType {
  vip = 'vip',
  all = 'all',
}

export enum SupportTicketPriority {
  normal = '0',
  major = '1',
  critical = '2',
}

export enum SupportTicketActionName {
  priority = 'priority',
  status = 'status',
  assignedTo = 'assignedTo',
  orgId = 'orgId',
  brandId = 'brandId',
  categoryId = 'categoryId',
  channelId = 'channelId',
  website = 'website',
}

export interface SupportTicketActionValue {
  actionId: UserId | OrgId | BrandId | SupportCategoryId | SupportTicketPriority | SupportTicketType;
}

export interface TicketAdditionalResponse {
  opened: number;
}

export interface CompactSupportTicketResponse {
  id: TicketId;
  subject: string;
  fromName: string;
  fromEmail: string;
  orgName: string;
  orgId: OrgId;
  organization?: CompactOrgResponse;
  assignedTo?: CompactUserResponse;
  lastRespondTime?: number;
  lastReplyTime?: number;
  lastActivityTime?: number;
  lastThreadText: string;
  receivedAt: number;
  status: SupportTicketStatus;
  priority: SupportTicketPriority;
  website: string;
  tenantId: TenantId;
  tenantName: string;
  importId: string;
  categoryLabel: string;
  createdAt: number;
  updatedAt: number;
  trackingTime: boolean;
  tasks: number;
  openTasks: number;
  completedTasks: number;
}

export interface SupportTicketResponse extends CompactSupportTicketResponse {
  channel: CompactChannelResponse;
  brand?: BrandResponse;
  cleanSubject: string;

  category?: SupportCategoryResponse;
  replies: TicketReplyResponse[];
  files: TicketFileResponse[];
  emails: TicketEmailsResponse[];
  selectedEmails: TicketEmailsResponse[];
  senders: ChannelEmailSender[];
  //   orgSubNames: string;
  orgSubscriptions: VeryCompactOrgSubscriptions[];
  histories: TicketHistoryResponse[];
}

export interface TicketHistoryResponse {
  id: string;
  closedAt: number;
  createdAt: number;
  closedBy: VeryCompactUserResponse;
}

export interface VeryCompactOrgSubscriptions {
  title: string;
  lineItems: LineItem[];
}

export type TestTicketRequest = Pick<SupportTicketResponse, 'fromEmail' | 'subject'> & {
  toEmail: string;
  body: string;
};

export type SupportTicketRequest = Pick<SupportTicketResponse, 'subject'> & {
  orgId: OrgId;
  contactId: ContactId;
  body: string;
  channelId: ChannelId;
  signature?: boolean;
  messageCustomer?: boolean;
  additionalEmail?: string[];
  replyTo: string;
  replyCc: string[];
  responseType: TicketReplyResponseType;
};

export interface TicketSearchParams extends PageQuery {
  userId?: UserId | null;
  status?: SupportTicketStatus | null;
  tabId?: string;
  channelId?: ChannelId;
  sortBy: string;
  sortDirection: 'asc' | 'desc';
  priority?: SupportTicketPriority;
  categoryIds?: SupportCategoryId[];
}

export type TicketStatusId = string;

export interface SupportTicketStatusResponse {
  id: TicketStatusId;
  name: SupportTicketStatus;
}

export enum TicketNotificationType {
  created = 'ticket.created',
  updated = 'ticket.updated',
}
export interface TicketNotification {
  notificationType: TicketNotificationType;
  ticket: string;
  ticketId: TicketId;
  message: string;
}

export type TicketOrgRequest = {
  organization: OrgId;
  isContact: boolean;
} & Partial<ContactOrgRequest>;

export type SupportTicketPublicRequest = {
  subject: string;
  body: string;
  email: string;
  name: string;
  toEmail: string;
};
